export class ResetPasswordDTO {
    email: string;

    constructor(data: any) {
        this.email = data.email;
    }
}